// extracted by mini-css-extract-plugin
export default {"navBg":"Navbar_navBg__zclxu","text":"Navbar_text__qodmS"};